import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const TuitionFees = () => {
  return (
    <PlaceholderPage title="Tuition & Fees">
      Find detailed information about tuition fees, payment options, and additional costs for your program at FIC College.
    </PlaceholderPage>
  );
};

export default TuitionFees;
